import { getters } from '/@/modules/core/app/helpers/store';
import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';
import { DeprecatedClearWillError } from '/@/modules/core/app/errors/DeprecatedClearWillError';
import { DeprecatedRoute } from '/@/modules/auth/routes/deprecated.routes';
import Lang from '/@/modules/core/app/services/Lang';

export class CurrentEstateRouteConfig extends RouteConfig {
  /**
   * @returns {boolean}
   * @protected
   */
  async hasAccessToRoute() {
    const authUser = getters.auth.getUser();
    const estate = getters.auth.getCurrentEstate();

    this.isAccessingDeprecatedClearWill(estate, authUser);

    if (estate && (await this.canAccessRoute())) {
      return;
    }
    throw new Error();
  }

  /**
   * check whether the user is accessing deprecated free will url
   * @returns {?boolean}
   * @public
   */
  isAccessingDeprecatedClearWill(estate, authUser) {
    if (estate.isClearWill && !authUser.isImpersonated && !authUser.estateAccount.isActive) {
      throw new DeprecatedClearWillError(
        Lang.t('deprecated.will-url-error'),
        Lang.isFrench()
          ? DeprecatedRoute.DEPRECATED_CLEAR_WILL_FRENCH.path
          : DeprecatedRoute.DEPRECATED_CLEAR_WILL.path
      );
    }

    return false;
  }
}
